import * as THREE from 'three';
import type {Animation} from '../engine/types';
/** All clocks are supplied by the renderer. Completion never changes gameplay. */
export class AssetAnimation {
 readonly mixer:THREE.AnimationMixer;
 private actions=new Map<string,THREE.AnimationAction>();
 private key='';private visualState:Animation|null=null;
 constructor(readonly root:THREE.Object3D,clips:THREE.AnimationClip[],readonly mapping:Record<string,string>){
  this.mixer=new THREE.AnimationMixer(root);
  for(const clip of clips)this.actions.set(clip.name,this.mixer.clipAction(clip));
 }
 pose(animation:Animation,kind:string,virtualTick:number){
  if(animation.id===`${kind}.idle`&&this.visualState&&!this.visualState.loop){const previous=this.actions.get(this.mapping[this.visualState.id]);if(previous&&virtualTick<this.visualState.start+previous.getClip().duration/.6)animation=this.visualState;}
  this.visualState=animation;
  const name=this.mapping[animation.id]??this.mapping[`${kind}.idle`];
  const action=name?this.actions.get(name):undefined;
  if(!action)return;
  const key=`${name}:${animation.start}:${!!animation.loop}`;
  if(key!==this.key){
   this.mixer.stopAllAction();action.reset();action.enabled=true;action.paused=false;
   action.setLoop(animation.loop?THREE.LoopRepeat:THREE.LoopOnce,animation.loop?Infinity:1);
   action.clampWhenFinished=true;action.play();this.key=key;
  }
  // setTime alone cannot rewind a clamped, paused AnimationAction.
  action.paused=false;
  this.mixer.setTime(Math.max(0,(virtualTick-animation.start)*.6));
 }
 destroy(){this.mixer.stopAllAction();this.mixer.uncacheRoot(this.root);}
}
